import * as React from "react";

export function AuditBanner(): React.JSX.Element {
  return (
    <div
      role="status"
      data-testid="audit-banner"
      className="flex items-center gap-2.5 px-3.5 py-2.5 bg-[var(--accent-weak)] border border-[rgba(27,110,245,0.18)] rounded-[var(--radius-sm)] text-[13px] text-[var(--accent)] font-[500] mb-4"
    >
      <svg
        className="w-[18px] h-[18px] flex-shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
      Просмотр зафиксирован в Audit Log
    </div>
  );
}
